import Overlay from "ol/Overlay";
import { bd09ToMapCoord } from "../../utils/tiandituMap";

import gcbj from "../public/gcbj.png";
import gcbj_zyzbj from "../public/gcbj_zyzbj.png";
import gcbj_zyzlx from "../public/gcbj_zyzlx.png";
import gcbj_zyzzc from "../public/gcbj_zyzzc.png";
import gclx_zyzbj from "../public/gclx_zyzbj.png";
import gclx_zyzlx from "../public/gclx_zyzlx.png";
import gclx_zyzzc from "../public/gclx_zyzzc.png";
import gczc from "../public/gczc.png";
import gczc_zyzbj from "../public/gczc_zyzbj.png";
import gczc_zyzlx from "../public/gczc_zyzlx.png";
import gczc_zyzzc from "../public/gczc_zyzzc.png";
import lx from "../public/lx.png";
import station_close from "../public/station_close.png";
import washroom_mend from "../public/washroom_mend.png";
import zyzbj from "../public/zyzbj.png";
import zyzlx from "../public/zyzlx.png";
import zyzzc from "../public/zyzzc.png";

const Color = ["#B4B4B4", "#06D300", "#FF4940"];

function resolveIconUrl(type, state, transferPointStatus, workStatus, manStatus, womanStatus) {
  let urlImg;
  if (type == 1) {
    if (workStatus == 3) {
      urlImg = washroom_mend;
    } else if (workStatus == 2) {
      urlImg = station_close;
    } else if (workStatus == 1) {
      if (state == 0) {
        urlImg = lx;
      } else if (state == 2 && womanStatus == 0) {
        urlImg = gcbj;
      } else if (state == 2 && manStatus == 0) {
        urlImg = gcbj;
      } else if (state == 2 && womanStatus == 2) {
        urlImg = gcbj;
      } else if (state == 2 && manStatus == 2) {
        urlImg = gcbj;
      } else if (state == 1 && manStatus == 0) {
        urlImg = gczc;
      } else if (manStatus == 1 && womanStatus == 1) {
        urlImg = gczc;
      } else if (state == 1 && womanStatus == 0) {
        urlImg = gczc;
      } else if (state == 1 && manStatus == 2) {
        urlImg = gcbj;
      }
    }
  } else if (type == 2) {
    if (workStatus == 3) {
      urlImg = washroom_mend;
    } else if (workStatus == 2) {
      urlImg = station_close;
    } else if (workStatus == 1) {
      if (transferPointStatus == 2 && manStatus == 0 && womanStatus == 0) {
        urlImg = gcbj_zyzbj;
      } else if (transferPointStatus == 2 && state == 2 && manStatus == 2) {
        urlImg = gcbj_zyzbj;
      } else if (transferPointStatus == 2 && state == 2 && womanStatus == 2) {
        urlImg = gcbj_zyzbj;
      } else if (transferPointStatus == 2 && womanStatus == 1 && state == 1) {
        urlImg = gczc_zyzbj;
      } else if (transferPointStatus == 2 && manStatus == 1 && state == 1) {
        urlImg = gczc_zyzbj;
      } else if (transferPointStatus == 0 && manStatus == 1 && womanStatus == 2) {
        urlImg = gczc_zyzlx;
      } else if (transferPointStatus == 2 && manStatus == 0) {
        urlImg = gczc_zyzbj;
      } else if (transferPointStatus == 2 && womanStatus == 0) {
        urlImg = gczc_zyzbj;
      } else if (transferPointStatus == 0 && womanStatus == 1 && manStatus == 0) {
        urlImg = gczc_zyzlx;
      } else if (transferPointStatus == 0 && manStatus == 1 && womanStatus == 0) {
        urlImg = gczc_zyzlx;
      } else if (transferPointStatus == 0 && manStatus == 1 && womanStatus == 1) {
        urlImg = gczc_zyzlx;
      } else if (transferPointStatus == 0 && manStatus == 0 && womanStatus == 0) {
        urlImg = gclx_zyzlx;
      } else if (transferPointStatus == 0 && manStatus == 2 && womanStatus == 0) {
        urlImg = gcbj_zyzlx;
      } else if (transferPointStatus == 0 && manStatus == 2 && womanStatus == 1) {
        urlImg = gcbj_zyzlx;
      } else if (transferPointStatus == 0 && manStatus == 1 && womanStatus == 2) {
        urlImg = gcbj_zyzlx;
      } else if (transferPointStatus == 0 && manStatus == 0 && womanStatus == 2) {
        urlImg = gcbj_zyzlx;
      } else if (transferPointStatus == 0 && manStatus == 2 && womanStatus == 2) {
        urlImg = gcbj_zyzlx;
      } else if (transferPointStatus == 1 && womanStatus == 0 && manStatus == 1) {
        urlImg = gczc_zyzzc;
      } else if (transferPointStatus == 1 && womanStatus == 1 && manStatus == 0) {
        urlImg = gczc_zyzzc;
      } else if (transferPointStatus == 1 && manStatus == 0 && womanStatus == 0) {
        urlImg = gclx_zyzzc;
      } else if (transferPointStatus == 1 && manStatus == 1 && womanStatus == 1) {
        urlImg = gczc_zyzzc;
      } else if (transferPointStatus == 1 && manStatus == 2) {
        urlImg = gcbj_zyzzc;
      } else if (transferPointStatus == 1 && womanStatus == 2) {
        urlImg = gcbj_zyzzc;
      }
    }
  } else if (type == 3) {
    if (transferPointStatus == 1) {
      urlImg = zyzzc;
    } else if (transferPointStatus == 0) {
      urlImg = zyzlx;
    } else if (transferPointStatus == 2) {
      urlImg = zyzbj;
    }
  }
  return urlImg;
}

export default function createMapIconOverlay(
  map,
  lng,
  lat,
  text,
  fn,
  fns,
  fnss,
  type,
  state,
  transferPointStatus,
  workStatus,
  manStatus,
  womanStatus
) {
  const urlImg = resolveIconUrl(
    type,
    state,
    transferPointStatus,
    workStatus,
    manStatus,
    womanStatus
  );

  const container = document.createElement("div");
  container.className = "map-site-icon-overlay";
  container.style.position = "relative";
  container.style.display = "inline-block";
  container.style.cursor = "pointer";
  container.style.pointerEvents = "auto";

  const img = document.createElement("img");
  img.src = urlImg;
  img.style.display = "block";
  img.style.position = "relative";
  img.style.zIndex = "1";
  container.appendChild(img);

  const span = document.createElement("span");
  span.textContent = text;
  span.style.position = "absolute";
  span.style.left = "100%";
  span.style.top = "0";
  span.style.border = "solid 2px " + Color[transferPointStatus];
  span.style.borderRadius = "4px";
  span.style.backgroundColor = "white";
  span.style.marginLeft = "-4px";
  span.style.lineHeight = "1";
  span.style.padding = "4px";
  span.style.whiteSpace = "nowrap";
  span.style.zIndex = "2";
  container.appendChild(span);

  container.addEventListener("mouseover", fns);
  container.addEventListener("mouseout", fnss);
  container.addEventListener("click", fn);

  const overlay = new Overlay({
    element: container,
    // 图标底部中心对准坐标点，标签绝对定位不参与锚点计算
    positioning: "bottom-center",
    stopEvent: false,
  });
  overlay.setPosition(bd09ToMapCoord(lng, lat));
  map.addOverlay(overlay);
  return overlay;
}
